import React from 'react'
import { Tooltip, IconButton, Stack } from '@mui/material'
import { useNavigate } from 'react-router-dom';
import BuildIcon from '@mui/icons-material/Build';
import ReceiptIcon from '@mui/icons-material/Receipt';
import SummarizeIcon from '@mui/icons-material/Summarize';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
// import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

function VehicleButton({ rows, setRows, params, firstRow, field}) {

  const navigate= useNavigate()

 

  return (
    <Stack direction="row" spacing={1}>
      <Tooltip title="Estimate">
        <IconButton
          sx={{
            color: "#489C8F",
            "&:hover": { backgroundColor: "#df9797", color: "white" },
          }}
          onClick={() => navigate("/estimate")}
        >
          <SummarizeIcon sx={{ fontSize: "15px" }} />
        </IconButton>
      </Tooltip>

      <Tooltip title="Service Order">
        <IconButton
          sx={{
            color: "#0066b2",
            "&:hover": { backgroundColor: "#88a3c9", color: "white" },
          }}
          size="small"
          onClick={() => navigate("/service_Order")}
        >
          <BuildIcon sx={{ fontSize: "15px" }} />
        </IconButton>
      </Tooltip>

      <Tooltip title="Invoice">
        <IconButton
          sx={{
            color: "#212121",
            "&:hover": { backgroundColor: "#df9797", color: "white" },
          }}
          onClick={() => navigate("/Invoice")}
        >
          <ReceiptIcon sx={{ fontSize: "15px" }} />
        </IconButton>
      </Tooltip>
      <Tooltip title="Edit">
      <IconButton sx={{ color: '#0066b2', '&:hover': {backgroundColor: '#88a3c9', color: 'white' }}} size='small' >
        <ModeEditOutlineOutlinedIcon sx={{ fontSize: "15px" }} />
      </IconButton>

    </Tooltip>
      {/* <Tooltip title="Delete">
      <IconButton sx={{ color: '#CD5C5C', '&:hover': {backgroundColor: '#df9797', color: 'white' } }}  >
        <DeleteOutlineOutlinedIcon sx={{ fontSize: "15px"}}/>
      </IconButton>
      </Tooltip> */}
    </Stack>
  );

}
export default VehicleButton